<!--
 * @Description: 自定义页面管理
-->
<template>
	<div class="body">
		<div class="content_page">
			<el-button size="small f-white bg-theme" @click="addPage">新建页面</el-button>

			<!-- 头部 -->
			<div class="content-head">
				<img class="w45 h45 mr10 radius"
					src="https://img.yzcdn.cn/public_files/2016/05/13/8f9c442de8666f82abaf7dd71574e997.png!small.webp"
					alt="" />
				<div class="flex-column">
					<div class="flex col-center mb10">
						<span class="mr8 f15 f-bold">{{ homePage.name }}</span>
						<div class="p4 r3 bg-theme f13 f-white">首页</div>
					</div>
					<span class="f14 f-theme pointer" @click="editPage(homePage)">编辑</span>
				</div>
			</div>




			<!-- 表格 -->
			<div class="mt30">


				<el-table :data="project.pages" style="width: 100%;" :header-cell-style="{
					background: '#f7f8fa',
					color: '#323233',
					fontWeight: 500,
				}">
					<el-table-column prop="name" label="标题">
						<template slot-scope="scope">
							<img v-show="scope.row.home" class="h16 w16 mr5"
								src="https://b.yzcdn.cn/channel-icon/h5-mobile.png" alt="" />
							<input v-model="scope.row.name" />
						</template>
					</el-table-column>
					<el-table-column prop="name" label="状态">
						<template slot-scope="scope"> 已创建 </template>
					</el-table-column>
					<el-table-column prop="name" label="ID">
						<template slot-scope="scope" style="width: 100px;"> {{ scope.row.id }} </template>
					</el-table-column>
					<el-table-column prop="remote" label="备注">
						<template slot-scope="scope">
							<input v-model="scope.row.remote" />
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<span class="mr5 f-theme pointer" @click="editPage(scope.row.id)">编辑</span>
							<span class="ml5 mr5 f-theme pointer" v-if="!scope.row.home"
								@click="setHomePage(scope.row)">设为主页</span>
							<!-- 					<span class="ml5 mr5 f-theme pointer" @click="setHomePage(scope.row)">数据</span> -->
							<span class="ml5 mr5 f-theme pointer" @click="copyPage(scope.row)">复制</span>
							<span class="mr5 f-theme pointer" @click="delPage(scope.row.id)">删除</span>

							<span class="ml5 mr5 f-red pointer" @click="copyPageCode(scope.row)">复制代码</span>
							<span class="ml5 mr5 f-red pointer" @click="pastePageCode(scope.row)">粘贴代码</span>

						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>



	</div>



</template>

<script>
import {
	mapMutations,
	mapGetters
} from "vuex";

export default {
	name: "mall-pages",
	data() {
		return {
			pasteCodeContent: ''
		};
	},
	computed: {
		...mapGetters(["project"]),
		homePage() {
			return this.project.pages.find((page) => page.home);
		},
	},
	methods: {
		...mapMutations(["setCurPage"]),

		// 新增页面
		addPage() {
			let page = {
				id: this.$getRandomCode(4),
				name: "新增页面",
				componentList: [],
				config: {
					backgroundColor: '',
				}, //页面背景图 标题 分享图片和文字等配置
				home: false,
			};
			this.project.pages.push(page);
		},

		// 复制页面
		copyPage(data) {
			let page = this.$cloneDeep(data);
			page.id = this.$getRandomCode(4);
			page.home = false;
			this.project.pages.push(page);
		},

		// 复制页面代码
		copyPageCode(data) {
			console.log("复制页面代码data", data);
			console.log("复制页面代码data.componentList", data.componentList);

			// 生成代码内容
			let codeContent = '';
			if (data.componentList) {
				// 直接将componentList转换为字符串显示
				codeContent = JSON.stringify(data.componentList, null, 2);
			} else {
				codeContent = '无代码内容';
			}
			console.log("复制页面代码codeContent", codeContent);

			// 使用Element UI的$prompt方法显示代码，允许用户选择和复制  (可复制后粘贴给别的页面使用)
			this.$prompt(
				'',
				'页面代码(可复制后粘贴给别的页面使用)',
				{
					confirmButtonText: '关闭',
					inputType: 'textarea',
					inputValue: codeContent,
					inputPlaceholder: '代码内容',
					inputRows: 15,
					width: '80%',
					// 打开弹窗后全选文本
					callback: (action, instance) => {
						if (action === 'confirm') {
							// 用户点击关闭，不需要做任何操作
						}
						// 打开弹窗后全选文本
						setTimeout(() => {
							const textarea = instance.$el.querySelector('textarea');
							if (textarea) {
								textarea.select();
							}
						}, 100);
					}
				}
			).then(() => {
				// 用户点击关闭
			});
		},



		// 粘贴页面代码
		pastePageCode(data) {
			console.log("粘贴页面代码", data);
			// 弹出文本框让用户粘贴代码
			this.$prompt(
				'请粘贴代码内容(粘贴后会覆盖当前页面的代码),请谨慎操作',
				'粘贴代码',
				{
					confirmButtonText: '保存',
					cancelButtonText: '取消',
					inputType: 'textarea',
					inputPlaceholder: '请粘贴代码内容',
					inputRows: 15,
					width: '80%'
				}
			).then(({ value }) => {
				console.log('粘贴的代码内容', value);
				try {
					// 尝试解析JSON
					const parsedData = JSON.parse(value);
					// 检查解析后的数据是否是对象或数组
					if (typeof parsedData === 'object' && parsedData !== null) {
						// 检查是否至少有一个对象包含"component"键
						let hasComponentKey = false;
						if (Array.isArray(parsedData)) {
							// 是数组，检查数组中的对象
							hasComponentKey = parsedData.some(item =>
								typeof item === 'object' &&
								item !== null &&
								'component' in item
							);
						} else {
							// 是对象，检查对象本身
							hasComponentKey = 'component' in parsedData;
						}

						if (hasComponentKey) {
							data.componentList = parsedData;
							this.$message.success('代码已粘贴并保存');
						} else {
							// 没有找到component键，显示错误消息
							this.$message.error('解析代码失败，请确保粘贴的JSON数据中至少有一个对象包含"component"键');
						}
					} else {
						// 不是对象或数组，显示错误消息
						this.$message.error('解析代码失败，请确保粘贴的是有效的JSON对象或数组');
					}
				} catch (error) {
					console.error('解析代码失败:', error);
					this.$message.error('解析代码失败，请确保粘贴的是有效的JSON格式');
				}
			}).catch(() => {
				// 用户取消粘贴
			});
		},

		// 编辑页面
		editPage(id) {
			//console.log("编辑页面", this.project.pages, id);
			let page = this.project.pages.find((page) => (page.id == id));
			//console.log('当前打开的页面的参数', page);
			//如果没有 config: {}, //页面背景图 标题 分享图片和文字等配置 就补充一个
			console.log("-------->有没有config", page.hasOwnProperty('config'));
			if (!page.hasOwnProperty('config')) {
				page.config = {
					backgroundColor: '',
				}; //页面背景图 标题 分享图片和文字等配置	
			}


			this.setCurPage(page);
			this.$router.push({
				name: "page-build"
			});
		},

		// 删除页面
		delPage(id) {

			// this.$notify({
			// 	title: "失败",
			// 	message: "禁止用户删除页面", 
			// 	type: "warning",
			// });
			let that = this;
			this.$confirm("您确认要删除该页面?删除完点击保存后生效,生效后无法还原!请谨慎操作!", "删除页面", {
				confirmButtonText: "确定删除",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				//数据库找到记录删除
				let i = that.project.pages.findIndex((page) => page.id == id);
				that.project.pages.splice(i, 1);
				//页面刷新
			});




		},


		// 设置主页
		setHomePage(data) {
			this.project.pages.forEach((page) => (page.home = false));
			data.home = true;
			// this.$forceUpdate();
		},
	},
};
</script>

<style lang="scss" scoped>
input {
	border: 0;
	font-size: 13px;
	/*no*/
}

.f-red {
	color: red;
}

.body {
	padding: 15px;
	overflow: auto;
	/*no*/

	.content_page {
		width: 100%;
		/*no*/
		// height: 700px;
		/*no*/
		padding: 40px 20px;
		/*no*/
		background: #fff;

		.content-head {
			display: flex;
			align-items: flex-start;
			padding: 20px 30px;
			/*no*/
			margin-top: 15px;
			background: #f7f8fa;
		}
	}
}
</style>